import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_safety_measures_in_place_regarding_onsite_veh'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_safety_measures_in_place_regarding_onsite_veh',
  name: 'Does the facility have safety measures in place regarding on-site vehicle traffic',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ONLY_AUTHORIZED_PEOPLE_VEHICLES_ARE_ALLOWED_TO_DRIVE_ON_SITE',
      text: 'Only authorized people/vehicles are allowed to drive on-site',
      externalIds: [
        {
          id: 'hs-15--1-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VEHICLES_ARE_DRIVEN_AT_AN_APPROPRIATE_SPEED',
      text: 'Vehicles are driven at an appropriate speed',
      externalIds: [
        {
          id: 'hs-15--1-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAFFIC_LANES_AND_WALK_PATHS_ARE_CLEARLY_MARKED',
      text: 'Traffic lanes and walk paths are clearly marked',
      externalIds: [
        {
          id: 'hs-15--1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VEHICLES_ARE_IN_GOOD_WORKING_CONDITION',
      text: 'Vehicles are in good working condition',
      externalIds: [
        {
          id: 'hs-15--1-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ONLY_AUTHORIZED_TRAINED_AND_QUALIFIED_PEOPLE_DRIVE_VEHICLES',
      text: 'Only authorized, trained, and qualified people drive vehicles',
      externalIds: [
        {
          id: 'hs-15--1-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VEHICLES_ARE_USED_FOR_PURPOSES_FOR_WHICH_THEY_ARE_INTENDED_AND_',
      text: 'Vehicles are used for purposes for which they are intended and designed',
      externalIds: [
        {
          id: 'hs-15--1-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROVIDES_VISUAL_MANAGEMENT_SUCH_AS_INDICATORS_CONVEX_M',
      text: 'Facility provides visual management such as indicators, convex mirrors in dead ends, reflectors, etc., to ensure safe driving practices on facility premises',
      externalIds: [
        {
          id: 'hs-15--1-7x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-15--1-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ONLY_AUTHORIZED_PEOPLE_VEHICLES_ARE_ALLOWED_TO_DRIVE_ON_SITE',
                'VEHICLES_ARE_DRIVEN_AT_AN_APPROPRIATE_SPEED',
                'TRAFFIC_LANES_AND_WALK_PATHS_ARE_CLEARLY_MARKED',
                'VEHICLES_ARE_IN_GOOD_WORKING_CONDITION',
                'ONLY_AUTHORIZED_TRAINED_AND_QUALIFIED_PEOPLE_DRIVE_VEHICLES',
                'VEHICLES_ARE_USED_FOR_PURPOSES_FOR_WHICH_THEY_ARE_INTENDED_AND_',
                'FACILITY_PROVIDES_VISUAL_MANAGEMENT_SUCH_AS_INDICATORS_CONVEX_M',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-15',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14230,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
